export default class Entity {
  #subEntityPan;
  #subEntityName;
  #subEntityId;
  #subUser;
  #id;
  #primaryEntityId;
  #primaryEntityName;
  #primaryUser;
  #isActive;
  #isPrimary;
  #isFavourite;

  constructor(id, sen, pan, pei, pen, pUser, sUser, sEntityId, isFavourite) {
    this.#id = id;
    this.#subEntityName = sen;
    this.#subEntityPan = pan;
    this.#primaryEntityId = pei;
    this.#primaryEntityName = pen;
    this.#primaryUser = pUser;
    this.#subUser = sUser;
    this.#subEntityId = sEntityId;
    this.#isActive = false;
    this.#isPrimary = false;
    this.#isFavourite = isFavourite;
  }

  getIsActive() {
    return this.#isActive;
  }

  setIsActive(a) {
    this.#isActive = !!a;
  }
  getId() {
    return this.#id;
  }
  #setId(id) {
    this.#id = id;
  }
  getSubEntityId() {
    return this.#subEntityId;
  }
  #setSubEntityId(id) {
    this.#subEntityId = id;
  }

  getSubEntityName() {
    return this.#subEntityName;
  }
  #setSubEntityName(name) {
    this.#subEntityName = name;
  }

  getPrimaryEntityName() {
    return this.#primaryEntityName;
  }
  #setPrimaryEntityName(name) {
    this.#primaryEntityName = name;
  }
  getPrimaryUser() {
    return this.#primaryUser;
  }
  #setPrimaryUser(name) {
    this.#primaryUser = name;
  }
  getSubUser() {
    return this.#subUser;
  }
  #setSubUser(name) {
    this.#subUser = name;
  }

  getPrimaryEntityId() {
    return this.#primaryEntityId;
  }

  #setPrimaryEntityId(pei) {
    this.#primaryEntityId = pei;
  }

  getSubEntityPan() {
    return this.#subEntityPan;
  }
  #setSubEntityPan(pan) {
    this.#subEntityPan = pan;
  }

  getIsFavourite() {
    return this.#isFavourite;
  }
  setIsFavourite(isFavourite) {
    this.#isFavourite = isFavourite;
  }
}
